import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidatorFn, ValidationErrors } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PlatformApiService } from '../services/platform-api.service';
import { ThemeManagerService } from '../services/theme-manager.service';
import { Account, ApiKey, RoleType } from '../models/AccountModel';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

const confirmPasswordValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
  const confirmCheck = (control.get('userPassword') && control.get('userConfirmPassword') && control.get('userPassword').value != control.get('userConfirmPassword').value) ? { passwordNoMatch: true } : null;

  if (confirmCheck) {
    control.get('userConfirmPassword').setErrors({ passwordNoMatch: true });
  }

  return null;
}

@Component({
  selector: 'app-connectwise-provisioning',
  templateUrl: './connectwise-provisioning.component.html',
  styleUrls: ['./connectwise-provisioning.component.scss']
})
export class ConnectwiseProvisioningComponent implements OnInit {
  account: Account;
  apiKey: ApiKey;
  isSaving = false;

  provisioningForm = new FormGroup ({
    companyId: new FormControl('', [Validators.required]),
    partnerDomain: new FormControl('', [Validators.required]),
    apiPublicKey: new FormControl('', [Validators.required]),
    apiPrivateKey: new FormControl('', [Validators.required]),
    userFirstName: new FormControl('', [Validators.required]),
    userLastName: new FormControl('', [Validators.required]),
    userEmail: new FormControl('', [Validators.email, Validators.required]),
    userPassword: new FormControl('', [Validators.required]),
    userConfirmPassword: new FormControl('', [Validators.required]),
  }, [confirmPasswordValidator]);

  constructor(public themeManager: ThemeManagerService, private _platformApi: PlatformApiService, private _router: Router) { }

  ngOnInit() {
    this.themeManager.setThemeClass('connectwise-theme');
  }

  onProvision() {
    if (this.provisioningForm.valid) {
      let calculatedDomain = this.provisioningForm.value.partnerDomain.toLowerCase();
      let domainArray = calculatedDomain.split('://');
      if (domainArray.length > 1) {
        calculatedDomain = domainArray[1];
      }
      domainArray = calculatedDomain.split('/');
      if (domainArray.length > 1) {
        calculatedDomain = domainArray[0];
      }

      this.isSaving = true;
      const userJson = {
        userId: null,
        issuer: environment.cognitoJwtIssuer,
        firstName: this.provisioningForm.value.userFirstName,
        lastName: this.provisioningForm.value.userLastName,
        email: this.provisioningForm.value.userEmail,
        password: this.provisioningForm.value.userPassword,
        roles: [RoleType.USER],
      }

      // this._platformApi.provisionConnectWiseMsp(this.provisioningForm.controls.companyId.value, calculatedDomain, this.provisioningForm.controls.apiPublicKey.value, this.provisioningForm.controls.apiPrivateKey.value, userJson).subscribe(resp => {
      //   this.account = resp.account;
      //   this.apiKey = resp.apiKey;
      //   this.isSaving = false;
      // }, err => {
      //   console.log(err, err.status);
      //   if (err.status == 401) {
      //     this.provisioningForm.controls.apiPublicKey.setErrors({invalid: true});
      //   } else if (err.status == 403) {
      //     this.provisioningForm.controls.apiPublicKey.setErrors({invalidPermissions: true});
      //   } else if (err.error) {
      //     if (err.error.code == 'CONNECTWISE_BAD_SITE') {
      //       this.provisioningForm.controls.partnerDomain.setErrors({invalid: true});
      //     } else if (err.error.code == 'CONNECTWISE_BAD_COMPANYID') {
      //       this.provisioningForm.controls.companyId.setErrors({invalid: true});
      //     } else if (err.error.code == 'USER_EXISTS') {
      //       this.provisioningForm.controls.userEmail.setErrors({notUnique: true});
      //     }
      // }
      //   this.provisioningForm.setErrors({saveError: true});
      //   this.isSaving = false;
      // })
    }
  }

  onRegister() {
    this._router.navigate(['/public/register'], {queryParams:{partner:'connectwise'}});
  }
}
